import React, { useState, useEffect, useRef } from "react";
import { Table, Input, Button, Typography, Divider, Modal } from "antd";
import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";
// import { ChangeStudentTableData,ChangeTrainerSearchText } from "../../../actions/adminAction";
import {
  changeStudentTableLoadingStatus,
  changeTrainerSearchText,
} from "../../../reducers/admin";
import { fetchStudentTableData } from "../../../features/adminAsync";
// import { GetAllTest } from "../../../actions/trainerAction";

import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import Alert from "../../common/alert";
import { SearchOutlined } from "@ant-design/icons";
import "./student.css";
import { getAllTestsName } from "../../../features/trainerAsync";

const Student = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [studentId, setStudentId] = useState("");
  const admin = useSelector((state) => state.admin);
  const trainer = useSelector((state) => state.trainer);
  const searchInput = useRef(null);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const openModal = (key) => {
    setStudentId(key);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOption("");
    setStudentId("");
  };

  const handleOk = async () => {
    try {
      const res = await SecurePost({
        url: `${apis.ASSIGN_TEST_STUDENT}`,
        data: {
          studentId,
          testId: selectedOption,
        },
      });

      if (res) {
        Alert("success", "Success", res.data.message);
        closeModal();
      }
    } catch (error) {
      console.error(error);
      const message = error.response
        ? error.response.data.message
        : error.message;
      Alert("error", "Error!", message);
    }
  };

  useEffect(() => {
    dispatch(fetchStudentTableData());
    dispatch(getAllTestsName());
  }, [dispatch]);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[admin.TrainersearchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    dispatch(changeTrainerSearchText(selectedKeys[0]));
  };

  const handleReset = (clearFilters, confrim) => {
    clearFilters();
    confrim();
    dispatch(changeTrainerSearchText(""));
  };

  // const options = trainer.AllTestsName.map((option) => (
  //   <option key={option._id} value={option._id}>
  //     {option.title}
  //   </option>
  // ));
  const nameColumnSearchProps = getColumnSearchProps("name");
  const emailColumnSearchProps = getColumnSearchProps("emailid");
  const contactColumnSearchProps = getColumnSearchProps("contact");
  const levelColumnSearchProps = getColumnSearchProps("level");

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "name",
      key: "name",
      width: "25%",
      ...nameColumnSearchProps,
      render: (text) => {
        const rendered = nameColumnSearchProps.render
          ? nameColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Email Id</span>,
      dataIndex: "emailid",
      key: "emailid",
      width: "25%",
      ...emailColumnSearchProps,
      render: (text) => {
        const rendered = emailColumnSearchProps.render
          ? emailColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Contact Number</span>,
      dataIndex: "contact",
      key: "contact",
      ...contactColumnSearchProps,
      render: (text) => {
        const rendered = contactColumnSearchProps.render
          ? contactColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Level</span>,
      dataIndex: "level",
      key: "level",
      ...levelColumnSearchProps,
      render: (text) => {
        const rendered = levelColumnSearchProps.render
          ? levelColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
  ];

  return (
    <div className="admin-table-container">
      <div className="register-trainer-form-header">
        <Typography.Title
          level={4}
          style={{ color: "#fff", textAlign: "center", margin: -6 }}
        >
          List of Students
        </Typography.Title>
      </div>
      <Table
        bordered={true} 
        columns={columns}
        dataSource={admin.studentTableData}
        size="medium"
        pagination={{ pageSize: 10 }} 
        loading={admin.loading}
        rowKey="_id"
        style={{ backgroundColor: "#fff", padding: "10px" }}
      />
      {/* <Modal
        open={isModalOpen}
        title={"Assign Test"}
        onOk={handleOk}
        onCancel={closeModal}
        style={{
          top: "20px",
          padding: "0px",
          backgroundColor: "rgb(155,175,190)",
        }}
        width="40%"
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <label htmlFor="select-option">Select an option:</label>
          <select
            id="select-option"
            value={selectedOption}
            onChange={handleChange}
            style={{
              fontSize: "16px",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              boxShadow: "0 2px 2px rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
          >
            <option value="">-- Select an option --</option>
            {options}
          </select>
        </div>
      </Modal> */}
    </div>
  );
};

export default Student;
